/*Tps-report*/
if(window.location.pathname.includes("admin/cards")){
    
    var options = {
        "columnDefs": [
            {
                "render": function(data, type, row){
                    return "<div class='color-box' style='background-color: "+data+"'></div>";
                },
                "targets": [0]
            }
        ]
    };
    
    $.each($(".data-table"), function(){
        $(this).data("options", options);
    });
    
}


// WEBPACK FOOTER //
// ./resources/assets/js/pages/admin/cards.js